module.exports = __webpack_public_path__ + "static/media/invoiceTemplatePDF.944f8643.png";